import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { Leftover, LeftoverBrief } from "../../shared/models/leftover.model";

@Injectable({ providedIn: 'root' })
export class LeftoverService {
  private static readonly BASE_URL = `${environment.apiUrl}/leftovers`;

  constructor(private http: HttpClient) {}

  getLeftovers(): Observable<Leftover[]> {
    return this.http.get<Leftover[]>(LeftoverService.BASE_URL);
  }

  getLeftoverById(id: number): Observable<Leftover> {
    return this.http.get<Leftover>(`${LeftoverService.BASE_URL}/${id}`);
  }

  addLeftover(leftover: Omit<Leftover, 'leftover_id'>): Observable<Leftover> {
    return this.http.post<Leftover>(LeftoverService.BASE_URL, leftover);
  }

  updateLeftover(leftover: Partial<Leftover>): Observable<Leftover> {
    return this.http.put<Leftover>(`${LeftoverService.BASE_URL}/${leftover.leftover_id}`, leftover);
  }

  deleteLeftover(id: number): Observable<void> {
    return this.http.delete<void>(`${LeftoverService.BASE_URL}/${id}`);
  }

  searchLeftoversBrief(q: string, limit = 20): Observable<LeftoverBrief[]> {
      const term = (q ?? '').trim();
      if (term.length < 2) {
        return of([]);
      }
      const params = new HttpParams()
        .set('q', term)
        .set('limit', String(limit));
      return this.http.get<LeftoverBrief[]>(
        `${LeftoverService.BASE_URL}/search`,
        { params }
      );
    }
}
